import { AvailableOperationStatus } from "../models/operations/available-operation-status"

export const operationStatus = {
    [AvailableOperationStatus.PENDIENTE]: 'signaturit_pro.general.documents.status.pending',
    [AvailableOperationStatus.ACTIVA]: 'signaturit_pro.general.documents.status.active',
    [AvailableOperationStatus.FINALIZADA]: 'signaturit_pro.general.documents.status.finished',
    [AvailableOperationStatus.DOCUMENTACION_RECHAZADA]: 'signaturit_pro.general.documents.status.rejected_documentation',
    [AvailableOperationStatus.RECHAZADA]: 'signaturit_pro.general.documents.status.rejected',
    [AvailableOperationStatus.CADUCADA]: 'signaturit_pro.general.documents.status.expired',
    [AvailableOperationStatus.CANCELADA]: 'signaturit_pro.general.documents.status.canceled',
    [AvailableOperationStatus.PENDIENTE_ENTREGA]: 'signaturit_pro.general.documents.status.pending_delivery',
    [AvailableOperationStatus.BLOQUEADA]: 'signaturit_pro.general.documents.status.blocked'
}